import { render, staticRenderFns } from "./TopLeftCmp.vue?vue&type=template&id=4b3037c1&"
import script from "./TopLeftCmp.vue?vue&type=script&lang=js&"
export * from "./TopLeftCmp.vue?vue&type=script&lang=js&"
import style0 from "./TopLeftCmp.vue?vue&type=style&index=0&id=4b3037c1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports